import { useContext } from 'react'
import { useSelector } from 'react-redux'

import { useForm, useLatestEntity, useThunkDispatch } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import defaultState, { requiredFields } from '@models/publicationProduct'

import * as publicationProductActions from '@redux/modules/publicationProduct'

const createPublicationProduct = (params) => {
  const { publicationProductParams, dispatch, requestOptions } = params
  const { createPublicationProduct: createFn } = publicationProductActions

  return dispatch(createFn(publicationProductParams, requestOptions))
}

const updatePublicationProduct = (params) => {
  const { publicationProductParams, dispatch, requestOptions } = params
  const { updatePublicationProduct: updateFn } = publicationProductActions

  return dispatch(updateFn(publicationProductParams, requestOptions))
}

const createOrEditPublicationProduct = params => new Promise((resolve, reject) => {
  const { publicationProduct, showCreateOrEditPublicationProductModal } = params

  if (showCreateOrEditPublicationProductModal){
    const payload = {
      publicationProduct,
    }

    showCreateOrEditPublicationProductModal(payload)

    resolve({ success: true, result: payload })
  }

  reject(new Error('showCreateOrEditPublicationProductModal not defined in PageContext callbacks'))
})

export function usePublicationProductForm(publicationProduct = {}, options = {}){
  const { validateOn } = options

  const publicationProductForm = useForm(
    defaultState,
    { entity: publicationProduct, requiredFields, validateOn },
    [publicationProduct.id, publicationProduct.cache_key],
  )

  return {
    ...publicationProductForm,
  }
}

const usePublicationProduct = (initEntity = {}) => {
  const { entity: publicationProduct } = useLatestEntity(initEntity, 'publicationProducts')

  const dispatch = useThunkDispatch()

  const { callbacks } = useContext(PageContext)
  const { showCreateOrEditPublicationProductModal } = callbacks || {}

  const { creating, updating } = useSelector(reduxState => reduxState.publicationProducts)

  return {
    callbacks: {
      createOrEditPublicationProduct: () => (
        createOrEditPublicationProduct({ publicationProduct, showCreateOrEditPublicationProductModal })
      ),
      createPublicationProduct: (publicationProductParams, requestOptions) => (
        createPublicationProduct({ publicationProductParams, dispatch, requestOptions })
      ),
      updatePublicationProduct: (publicationProductParams, requestOptions) => (
        updatePublicationProduct({ publicationProductParams, dispatch, requestOptions })
      ),
    },
    creating,
    updating,
  }
}

export default usePublicationProduct
